import Vue from 'vue'
import axios from 'axios'
import {
  VueAxios
} from './axios'
import {
  Modal,
  notification
} from 'ant-design-vue'

// 创建 axios 实例
const baseURL = process.env.NODE_ENV === 'production' ? 'https://vr.gdyfpt.com/' : '/';
const baseURLMobile = 'https://vr.gdyfpt.com/api'
const service = axios.create({
  baseURL: baseURL, // api base_url
  timeout: 9000 // 请求超时时间
})

const serviceMobile = axios.create({
  baseURL: baseURLMobile,
  timeout: 9000
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get('ACCESS_TOKEN')
    // console.log("------异常响应------", token)
    console.log("------异常响应------", error.response.status)
    switch (error.response.status) {
      case 403:
        notification.error({
          message: '系统提示',
          description: '拒绝访问',
          duration: 4,
          placement: 'topLeft'
        })
        break
      case 500:
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if (token && data.message == "Token失效，请重新登录") {
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // store.dispatch('Logout').then(() => {
          //     window.location.reload()
          // })
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                Vue.ls.remove('ACCESS_TOKEN')
                window.location.reload()
              })
            }
          })
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404:
        notification.error({
          message: '系统提示',
          description: '很抱歉，资源未找到!',
          duration: 4,
          placement: 'topLeft'
        })
        break
      case 504:
        notification.error({
          message: '系统提示',
          description: '网络超时',
          placement: 'topLeft'
        })
        break
      case 401:
        notification.error({
          message: '系统提示',
          description: '未授权，请重新登录',
          duration: 4,
          placement: 'topLeft'
        })
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        notification.error({
          message: '系统提示',
          description: data.message,
          duration: 4,
          placement: 'topLeft'
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  // const token = Vue.ls.get('ACCESS_TOKEN')
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

serviceMobile.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
  let res = response.data;
  if (response.data.status == 402) {
    notification.error({
      message: '登录信息已过期，请重新登录',
      description: '退出登录',
      placement: 'topLeft'
    })
    setTimeout(() => {
      store.dispatch('Logout').then(() => {})
      window.location.reload()
      var sevice = window.location.protocol + "//" + window.location.host + "/";

      var serviceUrl = encodeURIComponent(sevice);
      var casUrl = CAS_URL;
      window.location.href = casUrl + serviceUrl;
    }, 1500)

    return {};
  }
  return res
}, err)

serviceMobile.interceptors.response.use((response) => {
  let res = response.data;
  if (response.data.status == 402) {
    return {};
  }
  return res
}, (err) => {

})

const installer = {
  vm: {},
  install(Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios,
  serviceMobile as ajax,
  baseURL as baseURL
}


// WEBPACK FOOTER //
// ./src/utils/network.js